<template>
  <div>
    <div class="bg-white padding-sm text-left">
      <el-button type="primary" size="small" @click="openAddChainSupplierModal">
        添加供应链
      </el-button>
      <el-button type="primary" size="small" @click="openEditChainSupplierModel">
        修改供应链
      </el-button>
      <el-button type="primary" size="small" @click="openDeleteChainSupplierModel">
        删除供应链
      </el-button>
      <el-button type="primary" size="small" class="margin-left-sm" @click="openAddChainSupplierCatalogModal">
        添加分类
      </el-button>
      <el-button type="primary" size="small" class="margin-left-sm" @click="openEditChainSupplierCatalogModel">
        修改分类
      </el-button>
      <el-button type="primary" size="small" class="margin-left-sm" @click="openDeleteChainSupplierCatalogModel">
        删除分类
      </el-button>
      <el-button type="primary" size="small" class="margin-left-sm" @click="openAddProductModal">
        添加商品
      </el-button>
    </div>

    <el-row :gutter="20">
      <el-col :span="4" style="padding-right:0">
        <chain-supply-tree ref="chainSupplyTree" @switchFloor="handleSwitchFloor"
          @switchUnit="handleSwitchUnit"></chain-supply-tree>
      </el-col>
      <el-col :span="20" class="margin-top-xs">
        <el-card>
          <div slot="header" class="flex justify-between">
            <span>{{ $t('chainSupplier.queryCondition') }}</span>
          </div>
          <el-form :inline="true" :model="chainProductInfo.conditions" class="flex justify-start">
            <el-form-item>
              <el-input v-model="chainProductInfo.conditions.prodName"
                :placeholder="$t('chainProduct.inputProdName')"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="queryProductMethod">{{ $t('common.query') }}</el-button>
              <el-button @click="resetProductMethod">{{ $t('common.reset') }}</el-button>
            </el-form-item>
          </el-form>
        </el-card>

        <el-card class="margin-top-xs">
          <div slot="header" class="flex justify-between">
            <span>商品列表</span>
          </div>
          <el-table :data="chainProductInfo.products" style="width:100%">
            <el-table-column prop="productId" label="商品ID" align="center"></el-table-column>
            <el-table-column prop="coverPhoto" label="商品图片" align="center">
              <template slot-scope="scope">
                <el-image style="width:50px;height:50px" :src="scope.row.coverPhoto"
                  :preview-src-list="[scope.row.coverPhoto]">
                  <div slot="error" class="image-slot">
                    <img src="/img/noPhoto.jpg" style="width:50px;height:50px">
                  </div>
                </el-image>
              </template>
            </el-table-column>
            <el-table-column prop="catalogName" label="商品分类" align="center"></el-table-column>
            <el-table-column prop="prodName" label="商品名称" align="center"></el-table-column>
            <el-table-column prop="unitName" label="商品单位" align="center"></el-table-column>
            <el-table-column prop="sort" label="排序" align="center"></el-table-column>
            <el-table-column prop="state" label="状态" align="center">
              <template slot-scope="scope">
                {{ scope.row.state == '2002' ? '已上架' : '未上架' }}
              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间" align="center"></el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button-group v-if="ssuType == '1'">
                  <el-button size="mini" @click="openEditProductModel(scope.row)">修改</el-button>
                  <el-button size="mini" @click="openDeleteProductModel(scope.row)">删除</el-button>
                </el-button-group>
                <el-button v-if="ssuType == '2'" size="mini" @click="openViewProductModel(scope.row)">详情</el-button>
              </template>
            </el-table-column>
          </el-table>

          <div class="row margin-top-xs">
            <div class="col-sm-7">
              <div>说明注释</div>
            </div>
            <div class="col-sm-5 float-right">
              <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
                layout="total, prev, pager, next" :total="total">
              </el-pagination>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <add-chain-supplier ref="addChainSupplier"></add-chain-supplier>
    <edit-chain-supplier ref="editChainSupplier"></edit-chain-supplier>
    <delete-chain-supplier ref="deleteChainSupplier"></delete-chain-supplier>
    <add-chain-supplier-catalog ref="addChainSupplierCatalog"></add-chain-supplier-catalog>
    <edit-chain-supplier-catalog ref="editChainSupplierCatalog"></edit-chain-supplier-catalog>
    <delete-chain-supplier-catalog ref="deleteChainSupplierCatalog"></delete-chain-supplier-catalog>
    <delete-chain-product ref="deleteChainProduct"></delete-chain-product>
    <view-chain-supplier-product ref="viewChainSupplierProduct"></view-chain-supplier-product>
  </div>
</template>

<script>
import { listChainProduct } from '@/api/admin/chainProduct/chainProductApi'
import ChainSupplyTree from '@/components/admin/chainSupplyTree/chainSupplyTree'
import AddChainSupplier from '@/components/admin/addChainSupplier/addChainSupplier'
import EditChainSupplier from '@/components/admin/editChainSupplier/editChainSupplier'
import DeleteChainSupplier from '@/components/admin/deleteChainSupplier/deleteChainSupplier'
import AddChainSupplierCatalog from '@/components/admin/addChainSupplierCatalog/addChainSupplierCatalog'
import EditChainSupplierCatalog from '@/components/admin/editChainSupplierCatalog/editChainSupplierCatalog'
import DeleteChainSupplierCatalog from '@/components/admin/deleteChainSupplierCatalog/deleteChainSupplierCatalog'
import DeleteChainProduct from '@/components/admin/deleteChainProduct/deleteChainProduct'
import ViewChainSupplierProduct from '@/components/admin/viewChainSupplierProduct/viewChainSupplierProduct'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'ChainSupplierManage',
  components: {
    ChainSupplyTree,
    AddChainSupplier,
    EditChainSupplier,
    DeleteChainSupplier,
    AddChainSupplierCatalog,
    EditChainSupplierCatalog,
    DeleteChainSupplierCatalog,
    DeleteChainProduct,
    ViewChainSupplierProduct
  },
  data() {
    return {
      DEFAULT_PAGE: 1,
      DEFAULT_ROW: 10,
      chainProductInfo: {
        products: [],
        total: 0,
        records: 1,
        moreCondition: false,
        productId: '',
        conditions: {
          catalogId: '',
          catalogName: '',
          state: '',
          prodName: '',
          keyword: '',
          barCode: '',
          csId: ''
        },
        catalogs: []
      },
      ssuType: '',
      currentPage: 1,
      pageSize: 10,
      total: 0,
      shopId: ''
    }
  },
  created() {
    this.shopId = getShopId()
    console.log(this.chainProductInfo.moreCondition)
  },
  methods: {
    listProducts(page, rows) {
      this.chainProductInfo.conditions.page = page
      this.chainProductInfo.conditions.row = rows
      const param = {
        params: this.chainProductInfo.conditions
      }
      param.params.prodName = param.params.prodName.trim()

      listChainProduct(param.params).then(response => {
        const res = response.data
        this.chainProductInfo.total = res.total
        this.chainProductInfo.records = res.records
        this.chainProductInfo.products = res.data
        if (res.code === 404) {
          this.$message.error('请检查供应链信息是否正确。')
        }
        this.total = res.records
      }).catch(error => {
        console.log('请求失败处理', error)
      })
    },
    queryProductMethod() {
      this.listProducts(this.DEFAULT_PAGE, this.DEFAULT_ROW)
    },
    resetProductMethod() {
      this.chainProductInfo.conditions.prodName = ''
      this.chainProductInfo.conditions.categoryId = ''
      this.chainProductInfo.conditions.state = ''
      this.listProducts(this.DEFAULT_PAGE, this.DEFAULT_ROW)
    },
    openAddProductModal() {
      this.$router.push(`/pages/admin/addChainProduct?csId=${this.chainProductInfo.conditions.csId}`)
    },
    openEditProductModel(product) {
      this.$router.push(`/pages/admin/editChainProduct?productId=${product.productId}&csId=${product.csId}`)
    },
    openDeleteProductModel(product) {
      this.$refs.deleteChainProduct.open(product)
    },
    openAddChainSupplierModal() {
      this.$refs.addChainSupplier.open()
    },
    openEditChainSupplierModel() {
      if (!this.chainProductInfo.conditions.csId) {
        this.$message.warning('请先选择供应链')
        return
      }
      const chainSupplier = this.$refs.chainSupplyTree.getChainSupplierById(this.chainProductInfo.conditions.csId)
      this.$refs.editChainSupplier.open(chainSupplier)
    },
    openDeleteChainSupplierModel() {
      if (!this.chainProductInfo.conditions.csId) {
        this.$message.warning('请先选择供应链')
        return
      }
      const chainSupplier = this.$refs.chainSupplyTree.getChainSupplierById(this.chainProductInfo.conditions.csId)
      this.$refs.deleteChainSupplier.open(chainSupplier)
    },
    openAddChainSupplierCatalogModal() {
      if (!this.chainProductInfo.conditions.csId) {
        this.$message.warning('请先选择供应链')
        return
      }
      this.$refs.addChainSupplierCatalog.open({ csId: this.chainProductInfo.conditions.csId })
    },
    openEditChainSupplierCatalogModel() {
      if (!this.chainProductInfo.conditions.catalogId) {
        this.$message.warning('请先选择供应链类型')
        return
      }
      const chainSupplierCatalog = this.$refs.chainSupplyTree.getChainSupplierCatalogById(
        this.chainProductInfo.conditions.csId,
        this.chainProductInfo.conditions.catalogId
      )
      this.$refs.editChainSupplierCatalog.open(chainSupplierCatalog)
    },
    openDeleteChainSupplierCatalogModel() {
      if (!this.chainProductInfo.conditions.catalogId) {
        this.$message.warning('请先选择供应链类型')
        return
      }
      const chainSupplierCatalog = this.$refs.chainSupplyTree.getChainSupplierCatalogById(
        this.chainProductInfo.conditions.csId,
        this.chainProductInfo.conditions.catalogId
      )
      this.$refs.deleteChainSupplierCatalog.open(chainSupplierCatalog)
    },
    openViewProductModel(product) {
      this.$refs.viewChainSupplierProduct.open(product)
    },
    handleSwitchFloor(param) {
      this.chainProductInfo.conditions.catalogId = ''
      this.chainProductInfo.conditions.csId = param.csId
      this.ssuType = param.suType
      this.listProducts(this.DEFAULT_PAGE, this.DEFAULT_ROW)
    },
    handleSwitchUnit(param) {
      this.chainProductInfo.conditions.csId = param.csId
      this.chainProductInfo.conditions.catalogId = param.catalogId
      this.ssuType = param.suType
      this.listProducts(this.DEFAULT_PAGE, this.DEFAULT_ROW)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.listProducts(val, this.DEFAULT_ROW)
    }
  }
}
</script>

<style scoped>
.margin-top-xs {
  margin-top: 10px;
}

.margin-left-sm {
  margin-left: 10px;
}

.padding-sm {
  padding: 10px;
}

.bg-white {
  background-color: #fff;
}

.float-right {
  float: right;
}
</style>